import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Portal,
  Progress,
  Select,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useBreakpointValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import { ArrowLeftIcon, ArrowRightIcon, HamburgerIcon } from "@chakra-ui/icons";
import React, { FormEvent, useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "react-paginate";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import Loading from "../../../components/common/Loading";
import { DeferRequestModal } from "../../../components/trainee/enrolment/DeferRequest";
import download from "../../../img/download.svg";
import empty from "../../../img/emptystate1.svg";
import engineering from "../../../img/engring.png";
import { ICenterData } from "../../../models/admin/center/center,model";
import { IGetEnrolment } from "../../../models/course-enrolment.model";
import { IAvailableCourse } from "../../../models/trainee-course.model";
import trainerRoutes from "../../../pages/trainer/routes";
import CenterService from "../../../services/admin/center.service";
import { getLocalUserProfile } from "../../../services/auth.service";
import courseEnrolmentService from "../../../services/course-enrolment.service";
import coursesService from "../../../services/courses.service";
import program_moduleService from "../../../services/program_service/program_module.service";
import programsService from "../../../services/program_service/programs.service";
import { getFullDate } from "../../../utils/classOfDegree";
import courseRoutes from "../../courses/courseRoutes";

const MyCourses = () => {
  const navigate = useNavigate();
  const [availableCourses, setAvailableCourses] = useState<IAvailableCourse[]>(
    []
  );
  const [inProgress, setInProgress] = useState<IGetEnrolment[]>([]);
  const [enrolId, setCourseEnrolId] = useState("");
  const [completedCourses, setCompletedCourses] = useState<IGetEnrolment[]>([]);
  const [loading, setLoading] = useState(true);
  const [isDefer, setDefer] = useState(false);
  const [reload, setReload] = useState(false);
  const [current, setCurrent] = useState<any>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isPostingModalOpen, setIsPostingModalOpen] = useState(false);
  const [
    isChangeDisciplineSpecializationOpen,
    setIsChangeDisciplineSpecializationOpen,
  ] = useState(false);
  const toast = useToast();
  const [admissionCode, setAdmissionCode] = useState<string>("");
  const [specializationId, setSpecializationId] = useState("");
  const [specializationArr, setSpecializationArr] = useState([]);
  const [disciplineId, setDisciplineId] = useState("");
  const [disciplineArr, setDisciplineArr] = useState([]);
  const [programModule, setProgramModule] = useState<any>();
  const [programModuleId, setProgramModuleId] = useState<string>("");
  const [selectedCenter1, setSelectedCenter1] = useState("");
  const [selectedCenter2, setSelectedCenter2] = useState("");
  const [currentAvailablePage, setCurrentAvailablePage] = useState(0);
  const [currentProgressPage, setCurrentProgressPage] = useState(0);
  const [perPage, setPerPage] = useState(6);

  const pageRangeDisplayed = useBreakpointValue({
    base: 3,
    sm: 3,
    md: 5,
    lg: 5,
  });
  const showLabels = useBreakpointValue({ base: false, md: true });
  const modalSize = useBreakpointValue({ base: "xs", sm: "md", md: "md" });

  const openPostingModal = async (each: any) => {
    setAdmissionCode(each.code);
    try {
      program_moduleService.getProgramModuleById(each.course.id).then((res) => {
        setProgramModule(res.data);
      });
    } catch (e) {}
    setIsPostingModalOpen(true);
    setIsChangeDisciplineSpecializationOpen(false);
  };

  const closePostingModal = () => {
    setIsPostingModalOpen(false);
  };

  const openChangeDisciplineSpecializationModal = async (each: any) => {
    setAdmissionCode(each.code);
    try {
      programsService.getDisciplines().then((res) => {
        setDisciplineArr(res.data);
      });
      programsService.getSpecializations().then((res) => {
        setSpecializationArr(res.data);
      });
    } catch (e) {}
    setIsChangeDisciplineSpecializationOpen(true);
  };

  const closeChangeDisciplineSpecializationModal = () => {
    setIsChangeDisciplineSpecializationOpen(false);
  };

  const handlePostingSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const postingFormData = {
      admission_code: admissionCode,
      program_module_id: programModuleId,
      centre_one_id: selectedCenter1,
      centre_two_id: selectedCenter2,
    };

    try {
      const postingResponse = await coursesService.traineeChoosePosting(
        postingFormData
      );

      if (postingResponse.status == "success") {
        toast({
          title: "Request posting",
          description: "Posting request successful",
          status: "success",
          duration: 3000,
        });
      } else {
        toast({
          title: "Request posting",
          description: `${postingResponse.message}`,
          status: "error",
          duration: 3000,
        });
      }
    } catch (err) {
      toast({
        title: "Request posting",
        description: "Something went wrong",
        status: "error",
        duration: 3000,
      });
    } finally {
      closePostingModal();
      setAdmissionCode("");
      setProgramModuleId("");
      setSelectedCenter1("");
      setSelectedCenter2("");
    }
  };

  const handleChangeDisciplineSpecializationSubmit = async (
    e: FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
    const changeObject = {
      admission_code: admissionCode,
      program_discipline_id: disciplineId,
      program_specialization_id: specializationId,
    };

    try {
      const changeDiscSpecResponse =
        await programsService.traineeChangeDisciplineSpecialization(
          changeObject
        );

      toast({
        title: "Request new specialization/discipline",
        description: "Posting request successful",
        status: "success",
        duration: 3000,
      });
    } catch (err) {
      toast({
        title: "Request new specialization/discipline",
        description: "Something went wrong",
        status: "error",
        duration: 3000,
      });
    } finally {
      closePostingModal();
      setAdmissionCode("");
      setDisciplineId("");
      setSpecializationId("");
    }
  };

  useEffect(() => {
    // Fetch available courses
    coursesService
      .getAvailableCourses()
      .then((response) => {
        let center_array: ICenterData[] = [];

        // Fetch centers
        CenterService.getCenters(``)
          .then((res) => {
            const all_center = res.data.data;

            // Filter centers by category
            center_array = all_center.filter(
              (center: { category: string }) => center.category === "rtc"
            );
            const posting_center = all_center.filter(
              (center: { category: string }) => center.category === "field"
            );

            setCurrent(posting_center);

            // Filter and process available courses
            const availablecourses: IAvailableCourse[] = response;
            const realCourses = availablecourses.filter(
              (each) => each.course !== null
            );

            realCourses.forEach((acourse) => {
              const available_course_center: ICenterData[] = [];
              const center_id_array = acourse.centre_ids
                ? acourse.centre_ids.split(",")
                : null;

              if (center_id_array) {
                for (let i = 0; i < center_array?.length; i++) {
                  if (center_id_array.includes(center_array[i].id.toString())) {
                    available_course_center.push(center_array[i]);
                  }
                }
              }
              acourse.centers = available_course_center;
            });

            // Get user profile
            const user = getLocalUserProfile();
            if (user) {
              // Fetch enrolled courses
              courseEnrolmentService
                .getEnroledCourses(user.id.toString())
                .then((response) => {
                  const enrolledCourses = response.data;

                  const inProgressCourses = enrolledCourses.filter(
                    (course) =>
                      course.status === 5 && course.payment.amountpaid > 0
                  );

                  // Set in-progress courses
                  setInProgress(inProgressCourses);

                  // Filter available courses by removing enrolled ones
                  const filteredCourses = realCourses.filter(
                    (course) =>
                      !enrolledCourses.some(
                        (enrolledCourse) =>
                          enrolledCourse.course_id === course.course_id
                      )
                  );

                  // Set the filtered available courses
                  setAvailableCourses(filteredCourses);

                  const completed_courses = response.data.filter(
                    (course) => course.status === 3
                  );
                  setCompletedCourses(completed_courses);
                  setLoading(false);
                })
                .catch((err) => err);
            } else {
              // If no user is found, set available courses without filtering
              setAvailableCourses(realCourses);
              setLoading(false);
            }
          })
          .catch((err) => err);
      })
      .catch((err) => err);
  }, []);

  const viewCourse = async (course_id: string, course: IAvailableCourse) => {
    navigate(courseRoutes.mycourselink(course_id));
    sessionStorage.setItem("available_course", JSON.stringify(course));
  };

  const viewEachCourse = async (course_id: string) => {
    localStorage.setItem("eachCourseId", course_id);
    navigate(courseRoutes.CourseInformationLink(course_id));
  };
  const openDeferModal = async (id: string) => {
    setDefer(true);
    setCourseEnrolId(id);
    onOpen();
  };
  const reloadData = () => {
    setReload(!reload);
  };

  const currentAvailableItems = availableCourses.slice(
    currentAvailablePage * perPage,
    (currentAvailablePage + 1) * perPage
  );

  const currentProgressItems = inProgress.slice(
    currentProgressPage * perPage,
    (currentProgressPage + 1) * perPage
  );

  const handleAvailablePageChange = (page: any) => {
    setCurrentAvailablePage(page.selected);
  };

  const handleProgressPageChange = (page: any) => {
    setCurrentProgressPage(page.selected);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <DashboardHeader />
          <Box
            bg="#F9F8F8"
            minHeight="90vh"
            height="auto"
            pt="3rem"
            width={"100hw"}
            mx="auto"
          >
            <Tabs
              colorScheme="red"
              width={["90%", "90%", "70%", "60%"]}
              mx="auto"
            >
              <Box
                bg="white"
                px="2rem"
                roundedTop="lg"
                shadow="md"
                fontWeight="700"
                fontSize="20px"
                color="#353535"
                mx="auto"
                pt="20px"
                pb="15px"
                mt="20px"
              >
                My Courses
              </Box>
              <TabList
                px="1rem"
                roundedBottom="lg"
                shadow="md"
                bg="white"
                m="0 auto"
                pb="20px"
                width={"100%"}
              >
                <Tab fontSize={["12px", "13px", "16px", "16px"]}>
                  Available Courses
                </Tab>
                <Tab fontSize={["12px", "13px", "16px", "16px"]}>
                  In Progress
                </Tab>
                {/* <Tab fontSize={["12px", "13px", "16px", "16px"]}>Completed</Tab> */}
              </TabList>
              <TabPanels>
                {loading ? (
                  <Loading />
                ) : (
                  <TabPanel>
                    {loading && availableCourses.length == 0 ? (
                      <Loading />
                    ) : availableCourses.length > 0 ? (
                      <>
                        {currentAvailableItems.map((each, index) => (
                          <Box
                            width={"100%"}
                            bg="white"
                            key={index}
                            // width="60%"
                            mb="1.8rem"
                            mx="auto"
                            pt="10px"
                            pb="1rem"
                            boxShadow="md"
                            rounded="lg"
                            onClick={() => viewCourse(each.course.uuid, each)}
                            cursor="pointer"
                          >
                            <Box p="10px" width={"100%"} bg="white" mb="25px">
                              <Flex
                                mx="auto"
                                width="87%"
                                bg="white"
                                pb="8px"
                                pt="10px"
                                mb="24px"
                                borderBottom="2px solid"
                                borderColor="gray.200"
                                justifyContent="space-between"
                              >
                                <HStack
                                  justifyContent="space-between"
                                  width={"100%"}
                                  fontSize={["13px", "14px", "16px"]}
                                >
                                  <Text color="#9E9E9E" fontWeight={"600"}>
                                    Admission End Date :{" "}
                                    {getFullDate(each.admission_end)},
                                  </Text>
                                  <Text fontWeight={"600"}>
                                    Training Start Date :{" "}
                                    {getFullDate(each.training_start)}
                                  </Text>
                                  <Box
                                    px="15px"
                                    py="5px"
                                    bg="#EC3337"
                                    borderRadius="8px"
                                    color="white"
                                    fontSize="13px"
                                    fontWeight="600"
                                    onClick={() =>
                                      viewCourse(each.course.uuid, each)
                                    }
                                    cursor={"pointer"}
                                  >
                                    Enroll
                                  </Box>
                                </HStack>
                              </Flex>
                              <Flex
                                mx="auto"
                                width="87%"
                                bg="white"
                                pb="12px"
                                pt="15px"
                                justifyContent="space-between"
                                flexDirection={[
                                  "column",
                                  "column",
                                  "row",
                                  "row",
                                ]}
                              >
                                <Box width={["100%", "47%"]}>
                                  {each.course?.cover_image ? (
                                    <Image
                                      objectFit="cover"
                                      objectPosition={"center"}
                                      height="200px"
                                      width="100%"
                                      src={each.course?.cover_image}
                                    />
                                  ) : (
                                    <Image
                                      objectFit="cover"
                                      objectPosition={"center"}
                                      height="200px"
                                      width="100%"
                                      src={engineering}
                                    />
                                  )}
                                </Box>
                                <Box width={["100%", "47%"]}>
                                  <Text
                                    color="black"
                                    fontSize="22px"
                                    textTransform="capitalize"
                                    fontWeight="600"
                                    mb="21px"
                                  >
                                    {each.course.name.toLowerCase()}
                                  </Text>
                                  <Text
                                    color="#9E9E9E"
                                    fontSize="14px"
                                    fontWeight="400"
                                  >
                                    {each.course.description
                                      ? each.course.description.substring(
                                          0,
                                          200
                                        )
                                      : "Nil"}
                                  </Text>
                                  <Text
                                    fontSize="14px"
                                    mt="10px"
                                    fontWeight="600"
                                  >
                                    Training Centers:
                                  </Text>
                                  <Flex mb="21px">
                                    {each.centers ? (
                                      each.centers.map((center, indexC) => (
                                        <Text mr="5px" key={indexC}>
                                          {center.name},
                                        </Text>
                                      ))
                                    ) : (
                                      <Text>No center</Text>
                                    )}
                                  </Flex>
                                </Box>
                              </Flex>
                            </Box>
                          </Box>
                        ))}
                        <Box pb={{ base: "0.5rem", sm: "1rem" }}>
                          <Pagination
                            breakLabel="..."
                            nextLabel={
                              showLabels ? (
                                <ArrowRightIcon style={{ fontSize: 18 }} />
                              ) : null
                            }
                            onPageChange={handleAvailablePageChange}
                            pageRangeDisplayed={pageRangeDisplayed}
                            pageCount={Math.ceil(
                              availableCourses.length / perPage
                            )}
                            previousLabel={
                              showLabels ? (
                                <ArrowLeftIcon style={{ fontSize: 18 }} />
                              ) : null
                            }
                            containerClassName="pagination"
                            pageLinkClassName="page-num"
                            previousLinkClassName="page-num"
                            nextLinkClassName="page-num"
                            activeLinkClassName="active"
                            // renderOnZeroPageCount={null}
                          />
                        </Box>
                      </>
                    ) : (
                      <Box
                        bg="white"
                        width={"100%"}
                        mb="10px"
                        mx="auto"
                        pt="40px"
                        pb="70px"
                        rounded="lg"
                        shadow="sm"
                      >
                        <Box>
                          <Box mx="auto" width={"100px"} height="150px">
                            <Image src={empty} />
                          </Box>
                          <Text
                            textAlign="center"
                            fontWeight="600"
                            fontSize="24px"
                            color="#353535"
                          >
                            No Available Courses
                          </Text>
                          <Text
                            color="#353535"
                            textAlign="center"
                            fontSize="14px"
                          >
                            You will be able to enrol for a course here
                          </Text>
                        </Box>
                      </Box>
                    )}
                  </TabPanel>
                )}

                <TabPanel>
                  {loading && inProgress.length == 0 ? (
                    <Loading />
                  ) : inProgress.length > 0 ? (
                    <>
                      {currentProgressItems.map((each, index) => (
                        <Box
                          bg="white"
                          key={index}
                          width={"100%"}
                          mb="1.8rem"
                          mx="auto"
                          pt="10px"
                          pb="1rem"
                          boxShadow="md"
                          rounded="lg"
                        >
                          <Box p="8px" bg="white" mb="25px">
                            <Flex
                              mx="auto"
                              width="87%"
                              bg="white"
                              pb="8px"
                              pt="10px"
                              mb="24px"
                              borderBottom="2px solid"
                              borderColor="gray.200"
                              justifyContent="space-between"
                            >
                              <Flex
                                p="7px"
                                bg="white"
                                borderRadius="2px"
                                border="1px solid"
                                borderColor={"#EC3337"}
                                color="#EC3337"
                                fontSize="13px"
                                cursor="pointer"
                                fontWeight="600"
                                alignItems={"center"}
                                // height={"2.5rem"}
                                onClick={() => openDeferModal(each.uuid)}
                              >
                                Defer Admission
                              </Flex>
                              <HStack gap="1rem">
                                {each.course.is_program === 1 ? (
                                  <Menu>
                                    <MenuButton
                                      as={IconButton}
                                      aria-label="Options"
                                      icon={<HamburgerIcon />}
                                      variant="outline"
                                    />
                                    <MenuList>
                                      <MenuItem
                                        as="button"
                                        onClick={() => openPostingModal(each)}
                                      >
                                        Request New Posting Centre
                                      </MenuItem>
                                      <MenuItem
                                        as="button"
                                        onClick={() =>
                                          openChangeDisciplineSpecializationModal(
                                            each
                                          )
                                        }
                                      >
                                        Request New Discipline/Specialization
                                      </MenuItem>
                                    </MenuList>
                                  </Menu>
                                ) : (
                                  ""
                                )}
                              </HStack>
                            </Flex>
                            <Flex
                              onClick={() => viewEachCourse(each.course.uuid)}
                              cursor="pointer"
                              mx="auto"
                              width="87%"
                              bg="white"
                              pb="12px"
                              pt="15px"
                              justifyContent="space-between"
                              flexDirection={["column", "column", "row", "row"]}
                            >
                              <Box width={["100%", "47%"]}>
                                {each.course?.cover_image ? (
                                  <Image
                                    objectFit="cover"
                                    height="200px"
                                    width="100%"
                                    src={each.course?.cover_image}
                                  />
                                ) : (
                                  <Image
                                    objectFit="cover"
                                    height="100%"
                                    width="100%"
                                    src={engineering}
                                  />
                                )}
                              </Box>
                              <Box width={["100%", "47%"]}>
                                <Text
                                  color="black"
                                  fontSize="22px"
                                  textTransform="capitalize"
                                  fontWeight="600"
                                  mb="21px"
                                >
                                  {each.course.name.toLowerCase()}
                                </Text>
                                <Text
                                  color="#9E9E9E"
                                  fontSize="14px"
                                  fontWeight="400"
                                  mb="21px"
                                >
                                  {each.course.description
                                    ? each.course.description.substring(0, 200)
                                    : "Nil"}
                                  ...
                                </Text>
                              </Box>
                            </Flex>
                          </Box>
                        </Box>
                      ))}
                      <Box pb={{ base: "0.5rem", sm: "1rem" }}>
                        <Pagination
                          breakLabel="..."
                          nextLabel={
                            showLabels ? (
                              <ArrowRightIcon style={{ fontSize: 18 }} />
                            ) : null
                          }
                          onPageChange={handleProgressPageChange}
                          pageRangeDisplayed={5}
                          pageCount={Math.ceil(inProgress.length / perPage)}
                          previousLabel={
                            showLabels ? (
                              <ArrowLeftIcon style={{ fontSize: 18 }} />
                            ) : null
                          }
                          containerClassName="pagination"
                          pageLinkClassName="page-num"
                          previousLinkClassName="page-num"
                          nextLinkClassName="page-num"
                          activeLinkClassName="active"
                          // renderOnZeroPageCount={null}
                        />
                      </Box>
                    </>
                  ) : (
                    <Box
                      bg="white"
                      width="100%"
                      mb="10px"
                      mx="auto"
                      pt="40px"
                      pb="70px"
                      shadow="md"
                      rounded="lg"
                    >
                      <Box>
                        <Box mx="auto" width={"100px"} height="150px">
                          <Image src={empty} />
                        </Box>
                        <Text
                          textAlign="center"
                          fontWeight="600"
                          fontSize="24px"
                          color="#353535"
                        >
                          No Course In progress
                        </Text>
                        <Text
                          color="#353535"
                          textAlign="center"
                          fontSize="14px"
                        >
                          Enrol for a course by selecting a course on the
                          available courses section
                        </Text>
                      </Box>
                    </Box>
                  )}
                </TabPanel>
                <TabPanel>
                  {inProgress.length > 0 ? (
                    inProgress.map((each, index) => (
                      <Box
                        bg="white"
                        width="100%"
                        key={index}
                        mb="1.8rem"
                        mx="auto"
                        pt="10px"
                        pb="1rem"
                        boxShadow="md"
                        rounded="lg"
                        onClick={() =>
                          navigate(trainerRoutes.trainerCourses.CourseInfo)
                        }
                        cursor="pointer"
                      >
                        <Box p="8px" bg="white" mb="25px">
                          <Flex
                            mx="auto"
                            width="87%"
                            bg="white"
                            pb="8px"
                            pt="10px"
                            mb="24px"
                            borderBottom="2px solid"
                            borderColor="gray.200"
                            justifyContent="space-between"
                          >
                            <Box
                              p="7px"
                              bg="#EC3337"
                              borderRadius="8px"
                              color="white"
                              fontSize={["13px", "14px", "16px"]}
                              fontWeight="600"
                            >
                              Course Completed
                            </Box>
                            <Image
                              objectFit="contain"
                              width={["30px", "30px"]}
                              src={download}
                            />
                          </Flex>
                          <Flex
                            mx="auto"
                            width="87%"
                            bg="white"
                            pb="12px"
                            pt="15px"
                            justifyContent="space-between"
                            flexDirection={[
                              "column",
                              "column",
                              "column",
                              "row",
                            ]}
                          >
                            <Box width={["100%", "100%", "100%", "47%"]}>
                              <Image
                                objectFit="cover"
                                height={"200px"}
                                objectPosition={"center"}
                                width="100%"
                                src={engineering}
                              />
                            </Box>
                            <Box width={["100%", "100%", "100%", "47%"]}>
                              <Text
                                color="black"
                                fontSize="22px"
                                fontWeight="600"
                                mb="21px"
                              >
                                Electrical maintenance course on switch gear
                              </Text>
                              <Text
                                color="#9E9E9E"
                                fontSize="14px"
                                fontWeight="400"
                                mb="21px"
                              >
                                The courses are classified into technical and
                                Non-technical Courses. All these courses are
                                specifically designed for Generation,
                                Transmission Distribution professionals
                                specifically designed for Generation.All these
                                courses are specifically designed for Generation
                              </Text>
                              <Progress
                                value={100}
                                size="sm"
                                colorScheme="red"
                                width="100%"
                                borderRadius="0.5rem"
                                height="0.4rem"
                              />
                              <Text> Completion Status: 100%</Text>
                            </Box>
                          </Flex>
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Box
                      bg="white"
                      width="100%"
                      mb="10px"
                      mx="auto"
                      pt="40px"
                      pb="70px"
                      shadow="md"
                      rounded="lg"
                    >
                      <Box>
                        <Box mx="auto" width={"100px"} height="150px">
                          <Image
                            src={empty}
                            objectFit="cover"
                            objectPosition={"center"}
                          />
                        </Box>
                        <Text
                          textAlign="center"
                          fontWeight="600"
                          fontSize="24px"
                          color="#353535"
                        >
                          No Course
                        </Text>
                        <Text
                          color="#353535"
                          textAlign="center"
                          fontSize="14px"
                        >
                          You are yet to complete a course
                        </Text>
                      </Box>
                    </Box>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
            {isDefer && (
              <Portal>
                {" "}
                <DeferRequestModal
                  isOpen={isOpen}
                  onClosed={onClose}
                  isDefer={isDefer}
                  reload={reloadData}
                  data={enrolId}
                />{" "}
              </Portal>
            )}
          </Box>
          <Modal
            isOpen={isPostingModalOpen}
            onClose={closePostingModal}
            size={modalSize}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Posting Form</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <form onSubmit={handlePostingSubmit}>
                  <FormControl mt={4}>
                    <FormLabel>Program Module</FormLabel>
                    <Select
                      value={programModuleId}
                      placeholder="Select program module"
                      name="program_module_id"
                      onChange={(e: {
                        target: { value: React.SetStateAction<string> };
                      }) => setProgramModuleId(e.target.value)}
                    >
                      {programModule?.map((each: any, index: number) => {
                        return (
                          <option key={index} value={each.module_id}>
                            {each.module.name}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl mt={4}>
                    <FormLabel>Preferred Center (first choice)</FormLabel>
                    <Select
                      value={selectedCenter1}
                      placeholder="Select preferred center"
                      name="centre_one_id"
                      onChange={(e: {
                        target: { value: React.SetStateAction<string> };
                      }) => setSelectedCenter1(e.target.value)}
                    >
                      {current?.map((center: any, index: number) => {
                        return (
                          <option key={index} value={center.id}>
                            {center.name}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl mt={4}>
                    <FormLabel>Preferred Center (second choice)</FormLabel>
                    <Select
                      value={selectedCenter2}
                      placeholder="Select preferred center"
                      name="centre_two_id"
                      onChange={(e: {
                        target: { value: React.SetStateAction<string> };
                      }) => setSelectedCenter2(e.target.value)}
                    >
                      {current?.map((center: any, index: number) => {
                        return (
                          <option key={index} value={center.id}>
                            {center.name}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <Button mt={4} type="submit" colorScheme="red">
                    Submit
                  </Button>
                </form>
              </ModalBody>
            </ModalContent>
          </Modal>
          <Modal
            isOpen={isChangeDisciplineSpecializationOpen}
            onClose={closeChangeDisciplineSpecializationModal}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Change Discipline/Specialization</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <form onSubmit={handleChangeDisciplineSpecializationSubmit}>
                  <FormControl mt={4}>
                    <FormLabel>Select Discipline:</FormLabel>
                    <Select
                      value={disciplineId}
                      placeholder="Select new disipline"
                      name="discipline_id"
                      onChange={(e: {
                        target: { value: React.SetStateAction<string> };
                      }) => setDisciplineId(e.target.value)}
                    >
                      {disciplineArr?.map((each: any, index: number) => {
                        return (
                          <option key={index} value={each.id}>
                            {each.name}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl mt={4}>
                    <FormLabel>Select Specialization:</FormLabel>
                    <Select
                      value={specializationId}
                      placeholder="Select new specialization"
                      name="specialization_id"
                      onChange={(e: {
                        target: { value: React.SetStateAction<string> };
                      }) => setSpecializationId(e.target.value)}
                    >
                      {specializationArr?.map((each: any, index: number) => {
                        return (
                          <option key={index} value={each.id}>
                            {each.name}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <Button mt={4} type="submit" colorScheme="red">
                    Submit
                  </Button>
                </form>
              </ModalBody>
            </ModalContent>
          </Modal>
        </div>
      )}
    </>
  );
};

export default MyCourses;
